import gql from 'graphql-tag';

import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query, queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery';

import { preloadPersonalizedTemplatesV2OnboardingState } from './preloadPersonalizedTemplatesV2OnboardingState';
import { preloadNthUserHomeOnboardingRevampState } from './nth-user-home-onboarding/preloadNthUserHomeOnboardingRevampState';

export const GetPersonalSpaceDetailQuery = gql`
	query preloadPersonalizedTemplatesGetPersonalSpaceDetailQuery {
		user: confluence_atlassianUser(current: true) {
			id
			team
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
	}
`;

export const AllTemplatesQuery = gql`
	query preloadPersonalizedTemplatesAllTemplatesQuery {
		allTemplates(usePersonalSpace: true) {
			nodes {
				templateId
				contentBlueprintId
				blueprintModuleCompleteKey
				itemModuleCompleteKey
				name
			}
		}
	}
`;

export const SubAnchorQuery = gql`
	query preloadPersonalizedTemplatesSubAnchorQuery($accountId: ID!) {
		growthUnifiedProfile_getUnifiedProfile(accountId: $accountId) {
			paidChannelContext {
				confluence {
					subAnchor
				}
			}
		}
	}
`;

export const LicensedUserCountQuery = gql`
	query preloadPersonalizedTemplatesLicensedUserCountQuery {
		license {
			licenseConsumingUserCount
		}
	}
`;

export const preloadPersonalizedTemplates = (userId: string, accessStatus: AccessStatus) => {
	return waitForAllReturnWhenError([
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query({ query: GetPersonalSpaceDetailQuery }),
		query({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: AllTemplatesQuery,
			variables: {
				usePersonalSpace: true,
			},
		}),
		...(accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS
			? [
					queryAgg({
						/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
						query: SubAnchorQuery,
						variables: {
							accountId: userId || '',
						},
					}),
				]
			: []),
		...(accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS
			? [preloadPersonalizedTemplatesV2OnboardingState()]
			: []),
		preloadNthUserHomeOnboardingRevampState(),
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query({ query: LicensedUserCountQuery }),
	]);
};
